import service from './service';
import enterpriseCenter from './enterprise-center';
import enterpriseRecruit from './enterprise-recruit';
import enterpriseRegister from './enterprise-register';
import enterpriseResume from './enterprise-resume';
import enterpriseOrder from './enterprise-order';
import enterpriseInfo from './enterpriseInfo';
import personalCenter from './personal-center';
import personalResume from './personal-resume';
import personalSendlog from './personal-sendlog';
import personalCollect from './personal-collect';
import webConfig from './web-config';
import advertise from './advertise';
import face from './face';
import realtime from './realtime';
import message from './message';
import interview from './interview';

export default {
  getCompanys() {
    return service.get('/api/v1/company');
  },
  enterpriseCenter,
  enterpriseRecruit,
  enterpriseRegister,
  enterpriseResume,
  enterpriseOrder,
  enterpriseInfo,
  personalCenter,
  personalResume,
  personalSendlog,
  personalCollect,
  webConfig,
  advertise,
  face,
  realtime,
  message,
  interview
};



// WEBPACK FOOTER //
// ./src/api/index.js